import { createSlice } from '@reduxjs/toolkit';

export interface PatientListFilterState {
  tenancyId: number;
  clinics?: number[];
  primaryTeams?: string[];
  healthProfessionals?: string[];
  episodeStatus?: string;
  insightCategory?: string[];
  tags?: string[];
  patientName?: string;
  assigned?: number;
  favourite?: boolean;
  event_subcategory_id?: number;
  event_subcategory_name?: string;
  page?: number;
  sort?: 'firstName' | 'lastName' | 'dob' | 'lastEpisode';
  direction?: 'asc' | 'desc';
  max?: number;
  access_token?: string;
}

interface PatientListState extends PatientListFilterState {
  page: number;
  patients: any[];
  totalSize: number;
  currentPage: number;
  currentMax: number;
  isLoading: boolean;
  filterCriterion: any;
  filterState: PatientListFilterState;
  sortState: {
    sort: string;
    direction: string;
  };
}
const initialState: PatientListState = {
  page: 0,
  patients: [],
  totalSize: 0,
  currentPage: 0,
  currentMax: 0,
  isLoading: false,
  filterState: {
    clinics: [],
    primaryTeams: [],
    healthProfessionals: [],
    patientName: '',
    episodeStatus: '',
    insightCategory: [],
    event_subcategory_id: 0,
    event_subcategory_name: '',
    assigned: undefined,
    favourite: false,
    tags: [],
    tenancyId: 0,
  },
  sortState: {
    sort: 'activeInsights',
    direction: 'desc',
  },
  filterCriterion: {},
  tenancyId: 0,
};
export const patientListSlice = createSlice({
  name: 'patientList',
  initialState,
  reducers: {
    setFilterCriterion: (state, action) => {
      state.filterCriterion = action.payload;
    },
    startLoadingPatientList: (state /* action */) => {
      state.isLoading = true;
    },
    setPatientList: (state, action) => {
      state.isLoading = false;
      state.page = action.payload.page;
      state.patients = action.payload.patients;
      state.totalSize = action.payload.totalSize;
      state.currentPage = action.payload.currentPage;
      state.currentMax = action.payload.currentMax;
    },
    setSearchFilter: (state, action) => {
      state.filterState = action.payload;
    },
    setSort: (state, action) => {
      state.sortState = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  startLoadingPatientList,
  setPatientList,
  setSearchFilter,
  setSort,
  setFilterCriterion,
} = patientListSlice.actions;
